(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shpflt-addresses"]) return;
  try {
    
    function modifyAddress(){
      document.getElementsByClassName("modify__addresses").style.display = "block";
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-born-studios-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var LOADER = 'shpflt-events-loader';

  function getPageSize(el) {
    var v = parseInt(el.dataset.eventsPageSize || '1', 10);
    return v > 0 ? v : 1;
  }

  function initContainer(root) {
    initGrid(root);
    initEvents(root);
  }

  /* ── Studios grid (filters + show-more toggle) ── */

  function initGrid(root) {
    var block = root.querySelector('[data-grid-block]');
    if (!block) return;

    var citySel   = block.querySelector('[data-grid-city]');
    var discSel   = block.querySelector('[data-grid-discipline]');
    var clearBtn  = block.querySelector('[data-grid-clear]');
    var moreBtn   = block.querySelector('[data-grid-show-more]');
    var emptyEl   = block.querySelector('[data-grid-empty]');
    var items     = [].slice.call(block.querySelectorAll('.born-studios-page__grid-item'));
    var limit     = parseInt(block.dataset.visibleCount || '6', 10);
    var expanded  = false;

    function readUrlParams() {
      var params = new URLSearchParams(window.location.search);
      var city = params.get('city') || '';
      var disc = params.get('discipline') || '';
      if (citySel && city) citySel.value = city;
      if (discSel && disc) discSel.value = disc;
    }

    function writeUrlParams() {
      var url = new URL(window.location.href);
      var cVal = citySel ? citySel.value : '';
      var dVal = discSel ? discSel.value : '';
      if (cVal) { url.searchParams.set('city', cVal); } else { url.searchParams.delete('city'); }
      if (dVal) { url.searchParams.set('discipline', dVal); } else { url.searchParams.delete('discipline'); }
      history.replaceState(null, '', url.toString());
    }

    readUrlParams();

    function apply() {
      var cVal = citySel ? citySel.value : '';
      var dVal = discSel ? discSel.value : '';
      var filtered = cVal || dVal;

      if (clearBtn) clearBtn.hidden = !filtered;

      var matched = 0;
      for (var i = 0; i < items.length; i++) {
        var card = items[i].querySelector('.studio-card');
        if (!card) continue;
        var ok = (!cVal || (card.dataset.city || '') === cVal)
              && (!dVal || (card.dataset.disciplines || '').split(',').indexOf(dVal) !== -1);
        if (!ok) { items[i].hidden = true; continue; }
        matched++;
        items[i].hidden = !filtered && !expanded && matched > limit;
      }

      var shown = filtered ? matched : (expanded ? matched : Math.min(matched, limit));
      if (emptyEl) emptyEl.hidden = shown > 0;

      if (moreBtn) {
        var hide = filtered || expanded || matched <= limit;
        var wrap = moreBtn.closest('.born-studios-page__actions');
        moreBtn.hidden = hide;
        if (wrap) wrap.hidden = hide;
        moreBtn.textContent = expanded ? (moreBtn.dataset.labelLess || 'VER MENOS') : (moreBtn.dataset.labelMore || 'VER MÁS');
      }
    }

    if (citySel) citySel.addEventListener('change', function() { apply(); writeUrlParams(); });
    if (discSel) discSel.addEventListener('change', function() { apply(); writeUrlParams(); });
    if (clearBtn) clearBtn.addEventListener('click', function() {
      if (citySel) citySel.value = '';
      if (discSel) discSel.value = '';
      expanded = false;
      apply();
      writeUrlParams();
    });
    if (moreBtn) moreBtn.addEventListener('click', function() {
      expanded = !expanded;
      apply();
    });
    apply();
  }

  /* ── Events (upcoming + past via Section Rendering API) ── */

  function initEvents(root) {
    var grids = root.querySelectorAll('[data-events-type]');
    if (!grids.length) return;
    var pageSize = getPageSize(root);

    for (var i = 0; i < grids.length; i++) {
      var g = grids[i];
      if (!g.dataset.blog) {
        showEmpty(g, g.dataset.emptyText || 'No hay eventos registrados.');
        continue;
      }
      var initialMax = parseInt(g.dataset.max || '0', 10);
      g._blog     = g.dataset.blog;
      g._items    = [];
      g._page     = 0;
      g._pages    = 0;
      g._size     = pageSize;
      g._shown    = initialMax > 0 ? initialMax : pageSize;
      g._busy     = false;
      loadEvents(g);
    }
  }

  function fetchPage(blog, page, grid) {
    var base = '/blogs/' + encodeURIComponent(blog) + '?page=' + page;

    function parse(html) {
      var out = { articles: [], page: page, pages: 1 };
      if (!html || typeof html !== 'string') return out;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var loader = doc.querySelector('.events-loader');
      if (!loader) return out;
      out.pages = parseInt(loader.dataset.pages || '1', 10);
      var nodes = loader.querySelectorAll('.events-loader__item');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        out.articles.push({
          id:   n.dataset.id,
          ts:   parseInt(n.dataset.eventTs || n.dataset.published || '0', 10),
          tags: (n.dataset.tags || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean),
          el:   n
        });
      }
      return out;
    }

    return fetch(base + '&section_id=' + LOADER, { headers: { Accept: 'text/html' } })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(parse)
      .catch(function() {
        return fetch(base + '&sections=' + LOADER, { headers: { Accept: 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(j) {
            var h = j[LOADER] || (j.sections && j.sections[LOADER]);
            if (h && typeof h !== 'string') h = h.html || '';
            return parse(h || '');
          })
          .catch(function() { return { articles: [], page: page, pages: 1 }; });
      });
  }

  function matchType(art, type, now) {
    return type === 'upcoming'
      ? (art.ts >= now || art.tags.indexOf('upcoming') !== -1)
      : (art.ts <  now || art.tags.indexOf('past')     !== -1);
  }

  function loadEvents(g) {
    if (g._busy) return;
    g._busy = true;
    var type   = g.dataset.eventsType;
    var target = g._shown + 1;
    var now    = Math.floor(Date.now() / 1000);
    toggleActions(g, false);

    (function step() {
      if (g._items.length >= target || (g._pages && g._page >= g._pages)) {
        g._busy = false;
        renderGrid(g);
        return;
      }
      fetchPage(g._blog, g._page + 1, g).then(function(res) {
        g._page  = res.page;
        g._pages = res.pages;
        for (var i = 0; i < res.articles.length; i++) {
          if (matchType(res.articles[i], type, now)) g._items.push(res.articles[i]);
        }
        step();
      }).catch(function() {
        g._busy = false;
        renderGrid(g, true);
      });
    })();
  }

  function renderGrid(g, error) {
    var type = g.dataset.eventsType;
    var max  = g._shown;
    var all  = g._items;
    var count = Math.min(all.length, max);
    var hasMore = all.length > max;

    while (g.firstChild) g.removeChild(g.firstChild);

    if (!count) {
      var txt = error ? 'Error al cargar eventos.' : (g.dataset.emptyText || 'No hay eventos registrados.');
      var el  = document.createElement('div');
      el.className = 'born-studios-page__events-empty';
      el.innerHTML = '<p>' + txt + '</p>';
      g.appendChild(el);
      toggleActions(g, false);
      return;
    }

    var cls = type === 'upcoming' ? 'born-studios-page__events-item' : 'born-studios-page__past-item';
    for (var i = 0; i < count; i++) {
      var variant = all[i].el.querySelector('[data-variant="' + type + '"]');
      if (!variant) continue;
      var w = document.createElement('div');
      w.className = cls;
      w.setAttribute('role', 'listitem');
      w.innerHTML = variant.innerHTML;
      g.appendChild(w);
    }
    toggleActions(g, hasMore);
  }

  function toggleActions(grid, show) {
    var actions = grid.nextElementSibling;
    if (!actions || !actions.hasAttribute('data-events-load-more-actions')) {
      var block = grid.closest('[data-events-block]');
      actions = block ? block.querySelector('[data-events-load-more-actions]') : null;
    }
    if (!actions) return;
    if (show) {
      actions.removeAttribute('hidden');
      actions.style.removeProperty('display');
    } else {
      actions.setAttribute('hidden', '');
      actions.style.display = 'none';
    }
  }

  function onLoadMore(ev) {
    var btn = ev.target.closest('[data-events-load-more]');
    if (!btn) return;
    var sec = btn.closest('section');
    if (!sec) return;
    var g = sec.querySelector('[data-events-type]');
    if (!g || g._busy) return;
    g._shown += g._size;
    loadEvents(g);
  }

  function showEmpty(grid, text) {
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    var el = document.createElement('div');
    el.className = 'born-studios-page__events-empty';
    el.innerHTML = '<p>' + text + '</p>';
    grid.appendChild(el);
    toggleActions(grid, false);
  }

  /* ── Bootstrap ── */

  function boot() {
    document.addEventListener('click', function(ev) {
      if (ev.target.closest('.born-studios-page [data-events-load-more]')) onLoadMore(ev);
    });
    var nodes = document.querySelectorAll('.born-studios-page');
    for (var i = 0; i < nodes.length; i++) initContainer(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('.born-studios-page');
    if (s) initContainer(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shpflt-studio-detail"] && !Shopify.designMode) return;
  try {
    
(function() {
  var LOADER = 'shpflt-events-loader';

  function getPageSize(el) {
    var v = parseInt(el.dataset.eventsPageSize || '1', 10);
    return v > 0 ? v : 1;
  }

  function initStudioEvents(root) {
    var grids = root.querySelectorAll('[data-events-type]');
    if (!grids.length) return;
    var pageSize = getPageSize(root);

    for (var i = 0; i < grids.length; i++) {
      var g = grids[i];
      var blog = g.dataset.blog || '';
      var tag  = g.dataset.tag  || '';
      if (!blog || !tag) {
        showEmpty(g, g.dataset.emptyText || 'No hay eventos registrados.');
        continue;
      }
      var initialMax = parseInt(g.dataset.max || '0', 10);
      g._blog  = blog;
      g._tag   = tag;
      g._items = [];
      g._page  = 0;
      g._pages = 0;
      g._size  = pageSize;
      g._shown = initialMax > 0 ? initialMax : pageSize;
      g._busy  = false;
      loadEvents(g);
    }
  }

  function fetchPage(blog, tag, page) {
    var base = '/blogs/' + encodeURIComponent(blog)
      + '/tagged/' + encodeURIComponent(tag)
      + '?page=' + page;

    function parse(html) {
      var out = { articles: [], page: page, pages: 1 };
      if (!html || typeof html !== 'string') return out;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var loader = doc.querySelector('.events-loader');
      if (!loader) return out;
      out.pages = parseInt(loader.dataset.pages || '1', 10);
      var nodes = loader.querySelectorAll('.events-loader__item');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        out.articles.push({
          id:   n.dataset.id,
          ts:   parseInt(n.dataset.eventTs || n.dataset.published || '0', 10),
          tags: (n.dataset.tags || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean),
          el:   n
        });
      }
      return out;
    }

    return fetch(base + '&section_id=' + LOADER, { headers: { Accept: 'text/html' } })
      .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(parse)
      .catch(function() {
        return fetch(base + '&sections=' + LOADER, { headers: { Accept: 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(j) {
            var h = j[LOADER] || (j.sections && j.sections[LOADER]);
            if (h && typeof h !== 'string') h = h.html || '';
            return parse(h || '');
          })
          .catch(function() { return { articles: [], page: page, pages: 1 }; });
      });
  }

  function matchType(art, type, now) {
    return type === 'upcoming'
      ? (art.ts >= now || art.tags.indexOf('upcoming') !== -1)
      : (art.ts <  now || art.tags.indexOf('past')     !== -1);
  }

  function loadEvents(g) {
    if (g._busy) return;
    g._busy = true;
    var type   = g.dataset.eventsType;
    var target = g._shown + 1;
    var now    = Math.floor(Date.now() / 1000);
    toggleActions(g, false);

    (function step() {
      if (g._items.length >= target || (g._pages && g._page >= g._pages)) {
        g._busy = false;
        renderGrid(g);
        return;
      }
      fetchPage(g._blog, g._tag, g._page + 1).then(function(res) {
        g._page  = res.page;
        g._pages = res.pages;
        for (var i = 0; i < res.articles.length; i++) {
          if (matchType(res.articles[i], type, now)) g._items.push(res.articles[i]);
        }
        step();
      }).catch(function() {
        g._busy = false;
        renderGrid(g, true);
      });
    })();
  }

  function renderGrid(g, error) {
    var type  = g.dataset.eventsType;
    var max   = g._shown;
    var all   = g._items;
    var count = Math.min(all.length, max);
    var hasMore = all.length > max;

    while (g.firstChild) g.removeChild(g.firstChild);

    if (!count) {
      toggleActions(g, false);
      var block = g.closest('.studio-detail__block-events');
      if (block) block.style.display = 'none';
      return;
    }

    var cls = type === 'upcoming' ? 'studio-events__item' : 'studio-events__past-item';
    for (var i = 0; i < count; i++) {
      var variant = all[i].el.querySelector('[data-variant="' + type + '"]');
      if (!variant) continue;
      var w = document.createElement('div');
      w.className = cls;
      w.setAttribute('role', 'listitem');
      w.innerHTML = variant.innerHTML;
      g.appendChild(w);
    }
    toggleActions(g, hasMore);
    var visBlock = g.closest('.studio-detail__block-events');
    if (visBlock) visBlock.style.removeProperty('display');
  }

  function toggleActions(grid, show) {
    var block = grid.closest('.studio-detail__block-events');
    var actions = block ? block.querySelector('[data-events-load-more-actions]') : null;
    if (!actions) return;
    if (show) {
      actions.removeAttribute('hidden');
      actions.style.removeProperty('display');
    } else {
      actions.setAttribute('hidden', '');
      actions.style.display = 'none';
    }
  }

  function onLoadMore(ev) {
    var btn = ev.target.closest('[data-events-load-more]');
    if (!btn) return;
    var block = btn.closest('.studio-detail__block-events');
    if (!block) return;
    var g = block.querySelector('[data-events-type]');
    if (!g || g._busy) return;
    g._shown += g._size;
    loadEvents(g);
  }

  function showEmpty(grid, text) {
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    toggleActions(grid, false);
    var block = grid.closest('.studio-detail__block-events');
    if (block) block.style.display = 'none';
  }

  function boot() {
    document.addEventListener('click', function(ev) {
      if (ev.target.closest('.studio-detail [data-events-load-more]')) onLoadMore(ev);
    });
    var nodes = document.querySelectorAll('.studio-detail');
    for (var i = 0; i < nodes.length; i++) initStudioEvents(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var s = e.target.querySelector('.studio-detail');
    if (s) initStudioEvents(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
